import Tarjan from "../utils/Tarjan.js";

const Bootstrap = function(global) {
    const log = global.log.getLogger("f_mtac.application.bootstrap");
    log.setLevel(log.levels.INFO);
    const tarjan = new Tarjan();
    const modules = {};
    this.register_module = ({name, deps, init}) => {
        for (let module_name of deps) {
            tarjan.graph.connect_vertex(name, module_name);
        }
        modules[name] = {name, deps, init};
    };
    this.boot = async () => {
        var components_groups = tarjan.run();
        var components_prev = new Set(), components_next = new Set();
        var global_state = {};
        log.info("loading modules");
        for (let componets_group of components_groups) {
            for (let component of componets_group) {
                if (!component.connections.every(({name}) => (components_prev.has(name)))) {
                    log.debug("loading modules", [...components_next]);
                    await Promise.all([...components_next].map(name => modules[name].init(global_state)));
                    components_prev = new Set([...components_prev, ...components_next]);
                    components_next = new Set();
                }
                components_next.add(component.name);
            }
        }
        log.debug("loading modules", [...components_next]);
        await Promise.all([...components_next].map(name => modules[name].init(global_state)));
    };
};

export default Bootstrap;
